import React, { useEffect, useCallback, useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import {  fetchGrossisteSite } from "../../Redux/grossisteReduce";
import { verification } from "../../Redux/usersReduce";
import { fetchProduit } from "../../Redux/produitReduce";
import { commandeAdded, saveFile, cheeckProduit, extractionsCommande, verifCmd, getNumCommandGros } from "../../Redux/commandeReduce";
import { useDispatch } from "react-redux";
import ReactTable from "../../components/ReactTable/ReactTableBl.js";
import jwt_decode from "jwt-decode";
import { Alert } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { useTranslation } from 'react-multi-lang';
// react-bootstrap components
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import Swal from 'sweetalert2';

function AddCommande({ client, obj }) {
  var token = localStorage.getItem("x-access-token");
  const t = useTranslation();
  var decoded = jwt_decode(token);
  const saveTableCalled = useRef(false);
  const [total, setTotal] = useState(0);
  let file = "";
  const hrefURL = window.location.pathname;
  const id_site = client == "/medis" ? 2 : 3;

  const idUser = obj.user.id_role == 6 ? obj.user.id_grossiste : null;

  console.log(idUser)

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }
  const dispatch = useDispatch();
  const [extensionFile, setExtensionFile] = useState("");
  const [alert, setAlert] = useState(null);
  const [image, setImage] = useState("");
  const [save, setSave] = useState(false);
  const [produitExist, setProduitExist] = React.useState([]);
  const [produitExistDeleted, setProduitExistDeleted] = React.useState([]);

  //Produit en vrac
  const [resteZero, setResteZero] = useState(0);
  const [entitiesReste, setEntitiesReste] = useState([]);

  const [grossiste, setGrossiste] = React.useState(null);
  const [fourSelected, setFourSelected] = React.useState(null);
  const [optionFour, setOptionFour] = React.useState([
    {
      value: "",
      label: t("Wholesaler"),
      isDisabled: true,
    },
  ]);

  //getDate today
  var currentDate = new Date();
  var year = currentDate.getFullYear();
  var month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  var day = currentDate.getDate().toString().padStart(2, '0');
  var formattedDate = year + '-' + month + '-' + day;
  //table body
  const [entities, setEntities] = useState([]);
  const [entitiesEntete, setEntitiesEntete] = useState([{ Date: formattedDate, id_grossiste: idUser, Grossiste: null, Numero: null }]);
  const [uploadFile, setUploadFile] = React.useState();
  //Produit
  const [produitSelect, setProduitSelect] = React.useState([]);
  const [optionProduit, setOptionProduit] = React.useState([
    {
      value: "",
      label: "Produit",
      isDisabled: true,
    },
  ]);
  const [remise_industrie3, setRemise_industrie3] = useState(obj.user.id_role == 6 ? obj.user.remise_industrie3 : 0);
  const [remise_industrie2, setRemise_industrie2] = useState(obj.user.id_role == 6 ? obj.user.remise_industrie2 : 0);
  const [numPages, setNumPages] = useState(null);
  const [pdfFile, setPdfFile] = useState("");
  const pdfOptions = {
    cMapUrl: "cmaps/",
    cMapPacked: true,
  };

  /** start crop img**/
  const [traitment, setTraitment] = useState(false);
  const [image1, setImage1] = useState("");
  const [fileName, setFileName] = useState("");
  const [numCmd, setNumCmd] = useState(null);




  /** end crop img**/


  const getNumCmd = useCallback(async (idUser) => {
    // Get the last command number for this user
    const num = await dispatch(getNumCommandGros({ id_grossiste: idUser }));

    const now = new Date();
    const currentYear = now.getFullYear().toString().slice(-2); // e.g., "25"
    const currentMonth = (now.getMonth() + 1).toString().padStart(2, "0"); // e.g., "09"

    let formattedNum = '';

    if (!num.payload.num) {
      // No existing number → start at 001
      formattedNum = `CD-${currentYear}-${currentMonth}-001`;
    } else {
      // Split last number: "CD-25-09-007"
      const parts = num.payload.num.split("-");
      const existingYear = parts[1];
      const existingMonth = parts[2];
      const lastIncrement = parseInt(parts[3]);

      // Increment if same month & year, else reset
      const newIncrement =
        existingYear === currentYear && existingMonth === currentMonth
          ? lastIncrement + 1
          : 1;

      formattedNum = `CD-${currentYear}-${currentMonth}-${newIncrement
        .toString()
        .padStart(3, "0")}`;
    }

    // Update state
    setNumCmd(formattedNum);
    setEntitiesEntete(prev => {
      if (!prev || prev.length === 0) return [{ Numero: formattedNum }]; // create first row if empty
      const updated = [...prev];
      updated[0] = { ...updated[0], Numero: formattedNum }; // update existing first row


      return updated;
    });


  }, [dispatch, entitiesEntete]);



  //get Produit
  const getproduit = useCallback(async (remise_industrie3, remise_industrie2) => {
    var type = await dispatch(fetchProduit({ client }));
    var entities = type.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      arrayOption.push({
        value: e.id, label: e.Designation_1, code: e.Code_PCT, type: e.type, code_article: e.Code_article, prix: parseFloat(e.Prix).toFixed(3), cartonnage: e.Coefficient_UC,
        reste: null, commerce: e.commerce, id_site: e.id_site, site_produit: null, tag: e.tag, Remise: e.Remise === 1
          ? client == "/medis"
            ? remise_industrie2
            : remise_industrie3
          : 0
      });
    });
    setOptionProduit(arrayOption);
  }, [dispatch]);

  function deleteLigne(nb) {
    if (entities.length > 1) {
      var filtered = produitSelect.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });
      setProduitSelect(filtered);
      var filtered = entities.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });

      const list = [...entities]
      const prod = [...produitExist]
      var filteredExist = prod.filter(function (value, index, arr) {
        return value.produitfour !== list[nb].produitfour;
      });
      setProduitExist(filteredExist);

      setTable(filtered, 1);
      calculateTotalSum(filtered)
      setEntities(filtered);
      notify(1, t("supprimer_succes"));
    } else {
      notify(2, t("contient_ligne"));
    }
  }


  const hideAlert = () => {
    setAlert(null);
  };

  const confirmMessageProduit = (entities, produitSelect, rowIndex, v, produitExist, produitExistDeleted) => {
    var e = [...entities];
    const index = e.findIndex(item => item.idProduit === v.value);
    var select = [...produitSelect];
    select[rowIndex] = null
    setProduitSelect(select);
    if (index !== -1) {

      setAlert(
        <SweetAlert
          title=""
          style={{ display: "block", marginTop: "-100px" }}
          success
          onConfirm={() => confirmProduit(entities, produitSelect, rowIndex, v, produitExist, produitExistDeleted)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText={t("yes")}
          cancelBtnText={t("no")}
          showCancel
        >
          <h3 className="alert-title">{t("valider_produit")}</h3>
          {t("valider_produit_msg")}?
        </SweetAlert>
      );
    } else {
      confirmProduit(entities, produitSelect, rowIndex, v, produitExist, produitExistDeleted)
    }
  };


  const confirmProduit = useCallback(
    async (entities, produitSelect, rowIndex, v, produitExist, produitExistDeleted) => {
      hideAlert()
      var e = [...entities];
      var select = [...produitSelect];
      e[rowIndex].idProduit = v.value;
      e[rowIndex].designation = v.label;
      e[rowIndex].code = v.code;
      e[rowIndex].code_article = v.code_article;
      e[rowIndex].prix = v.prix;
      e[rowIndex].id_site = v.id_site;
      e[rowIndex].commerce = v.commerce;
      e[rowIndex].type = v.type;
      e[rowIndex].site_produit = v.site_produit;
      e[rowIndex].tag = v.tag;
      e[rowIndex].cartonnage = v.cartonnage;
      e[rowIndex].Remise = v.Remise;
      let quantite = parseInt(e[rowIndex].Quantite) || 0;
      let remiseDecimal = 0;
      if (e[rowIndex].Remise && e[rowIndex].Remise !== 0) {
        remiseDecimal =
          typeof e[rowIndex].Remise === "number"
            ? e[rowIndex].Remise
            : parseFloat(e[rowIndex].Remise);
        if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
      }

      if (v.cartonnage > 0 && quantite / v.cartonnage >= 0.6 && v.tag == 2) {
        quantite = Math.ceil(quantite / v.cartonnage) * v.cartonnage;

        const seuil = v.cartonnage * 0.6;
        notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
      }


      e[rowIndex].Quantite = quantite;
      e[rowIndex].nb = v.cartonnage > 0 && quantite ? parseInt(quantite / v.cartonnage) : 0;

      if (quantite && quantite < v.cartonnage) {
        e[rowIndex].reste = v.cartonnage - quantite;
      } else if (quantite % v.cartonnage > 0) {
        e[rowIndex].reste = v.cartonnage - (quantite % v.cartonnage);
      } else {
        e[rowIndex].reste = 0;

      }

      if ((e[rowIndex].tag == 1) && e[rowIndex].reste > 0) {
        e[rowIndex].quantite += e[rowIndex].reste
        quantite += e[rowIndex].reste
        e[rowIndex].reste = 0
        e[rowIndex].nb += 1
        e[rowIndex].style = "red"
        notify(2, "Le produit n’est recommandable que par multiple de carton");
      }


      e[rowIndex].total = quantite ? parseInt(v.prix * quantite * (1 - remiseDecimal)).toFixed(3) : 0;

      select[rowIndex] = v;
      setProduitSelect(select);
      const prod = [...produitExist]
      var filteredExist = prod.filter(function (value, index, arr) {
        return value.produitfour !== e[rowIndex].produitfour;
      });
      const prodD = [...produitExistDeleted]
      var filteredExistD = prodD.filter(function (value, index, arr) {
        return value.produitfour !== e[rowIndex].produitfour;
      });
      setProduitExist(filteredExist);
      setProduitExistDeleted(filteredExistD);
      calculateTotalSum(e)
      setEntities(e);
      setTable(e, 1);
    },
    []
  );

  function getMonthNumber(monthName) {
    var monthMap = {
      "jan": "01",
      "janvier": "01",
      "fév": "02",
      "février": "02",
      "mar": "03",
      "mars": "03",
      "avr": "04",
      "avril": "04",
      "mai": "05",
      "juin": "06",
      "juin": "06",
      "juil": "07",
      "juillet": "07",
      "août": "08",
      "aout": "08",
      "aug": "08",
      "août": "08",
      "aout": "08",
      "sept": "09",
      "septembre": "09",
      "oct": "10",
      "octobre": "10",
      "nov": "11",
      "novembre": "11",
      "déc": "12",
      "décembre": "12",
      "dec": "12",
      "decembre": "12"
    };
    return monthMap[monthName.toLowerCase()];
  }

  function setFormatDate(d) {
    var formatDate = null;
    if (d !== "" && d !== null) {
      var str = d.replaceAll("/", "");
      var str = str.replaceAll("-", "");
      if (isNaN(str.trim()) === false) {
        var pos = d.indexOf("/");
        var dataFormat = "";
        var dateTrime = "";
        var dataSplit = "";
        if (pos !== -1) {
          dateTrime = d.trim();
          dataSplit = dateTrime.split("/");
          if (dataSplit[2].length == 2) dataSplit[2] = "20" + dataSplit[2]
          dataFormat = dataSplit[2] + "-" + dataSplit[1] + "-" + dataSplit[0];
        } else {
          dateTrime = d.trim();
          dataSplit = dateTrime.split("-");
          dataFormat = dataSplit[2] + "-" + dataSplit[1] + "-" + dataSplit[0];
        }
        var newDate = new Date(dataFormat);
        if (newDate === "Invalid Date") formatDate = null;
        else formatDate = dataFormat;
      } else {
        var dataSplit = d.replaceAll(".", "");
        var dataSplit = dataSplit.split(" ");
        if (dataSplit.length == 3) {
          var day = dataSplit[0];
          var month = getMonthNumber(dataSplit[1]);
          var year = dataSplit[2];
          if (day < 10) {
            day = "0" + day;
          }
          dataFormat = year + "-" + month + "-" + day;
        }
        var newDate = new Date(dataFormat);
        if (newDate === "Invalid Date") formatDate = null;
        else formatDate = dataFormat;
      }
    }
    return formatDate;
  }
  const checkProd = useCallback(
    async (table) => {
      var arrayBody = [];
      var nocommerce = [];
      dispatch(cheeckProduit(table)).then((rowsdes) => {
        if (rowsdes !== undefined && rowsdes.payload.length > 0) {
          var prod = rowsdes.payload;
          var produitexit = [];
          for (var i = 0; i < prod.length; i++) {
            if (table[i].Quantite.toString().trim() != "" ) {
              var reste = 0
              var nbCarton = 0

              if (prod[i] !== null && typeof prod[i] !== "undefined" && prod[i] !== "undefined" && prod[i][8]==id_site) {
                var style = null
                table[i].Quantite = parseInt(table[i].Quantite)
                const quantiteInitiale = table[i].Quantite;
                const carton = parseInt(prod[i][6]);

                let resteDansCarton = quantiteInitiale / carton;

                // Ajout : arrondi si ≥ 60% de la contenance
                if (prod[i][9] == 2 && carton > 0 && resteDansCarton >= 0.6) {
                  table[i].Quantite = Math.ceil(parseInt(table[i].Quantite) / carton) * carton
                  var seuil = carton * 0.6;
                  style = "red";
                  notify(2, `Le produit ${table[i].Designation} doit être arrondi en caisse pour la quantité sup ${seuil}`);

                }

                // Recalcul après éventuel arrondi
                if (table[i].Quantite < carton) {
                  reste = carton - parseInt(table[i].Quantite);
                } else if ((table[i].Quantite % carton) > 0) {
                  reste = carton - (table[i].Quantite % carton);
                }

                nbCarton = carton > 0 ? parseInt(table[i].Quantite / carton) : 0;

                if ((prod[i][9] == 1) && reste > 0) {
                  table[i].Quantite += reste;
                  reste = 0
                  style = "red";
                  notify(2, `Le produit ${table[i].Designation} n’est recommandable que par multiple de carton`);
                }


                let remiseDecimal = 0;
                if (prod[i][10] === 1) {
                  remiseDecimal =
                    client === "/medis"
                      ? remise_industrie2
                      : remise_industrie3;

                  remiseDecimal = typeof remiseDecimal === "number" ? remiseDecimal : parseFloat(remiseDecimal);
                  if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
                }
                arrayBody.push({
                  idProduit: prod[i][2],
                  index: i,
                  designation: table[i].Designation != "" ? table[i].Designation : prod[i][0],
                  code: table[i].Code.toString().toLowerCase() != "not found" ? table[i].Code : "",
                  Quantite: prod[i][7] == 1 ? table[i].Quantite : 0,
                  prix: parseFloat(prod[i][4]).toFixed(3),
                  cartonnage: prod[i][7] == 1 ? carton : 0,
                  reste: prod[i][7] == 1 ? reste : 0,
                  nb: prod[i][7] == 1 ? nbCarton : 0,
                  commerce: prod[i][7],
                  id_site: prod[i][8],
                  code_article: prod[i][3],
                  tag: prod[i][9],
                  type: prod[i][11],
                  site_produit: null,
                  Remise: prod[i][10] === 1
                    ? client === "/medis"
                      ? remise_industrie2
                      : remise_industrie3
                    : 0,
                  total: (
                    parseFloat(prod[i][4]) * parseInt(table[i].Quantite) * (1 - remiseDecimal)
                  )
                });

                if (prod[i][7] == 0) {
                  nocommerce.push(table[i].Designation + " " + table[i].Code + " est non plus commercialisé ");
                }
              }
              else {
                produitexit.push({ index: parseInt(i + 1), designation: table[i].Designation, produitfour: table[i].Designation, code: table[i].Code.toString().toLowerCase() != "not found" ? table[i].Code : "", quantite: table[i].Quantite });
                arrayBody.push({
                  idProduit: null,
                  index: i,
                  designation: table[i].Designation,
                  produitfour: table[i].Designation,
                  code: table[i].Code.toString().toLowerCase() != "not found" ? table[i].Code : "",
                  Quantite: table[i].Quantite,
                  cartonnage: 0,
                  reste: null,
                  prix: 0,
                  tag: 0,
                  Remise: 0,
                  commerce: null,
                  site_produit: null,
                  id_site: null,
                  nb: nbCarton,
                  type: null,
                  code_article: null,
                  total: 0,
                });

              }
            }
          }
          if (produitexit.length > 0) setProduitExist(produitexit);
          calculateTotalSum(arrayBody)
          setEntities(arrayBody);
          if (nocommerce.length > 0) for (var i = 0; i < nocommerce.length; i++) {
            notify(2, nocommerce[i]);
          }
        } else {
          document.getElementById("loaderTable").classList.add("hidden")
          setEntities([]);
        }

        document.getElementById("loaderTable").classList.add("hidden");
      });
    },
    [dispatch]
  );


  const handleDeleteUnknownProducts = async () => {
    try {
      setProduitExistDeleted([...produitExist]);
      const updatedEntitiesReste = entitiesReste.filter(entity =>
        !produitExist.some(product => product.produitfour === entity.produitfour));

      const updatedEntities = entities.filter(entity =>
        !produitExist.some(product => product.produitfour === entity.produitfour)
      );
      setEntitiesReste(updatedEntitiesReste);
      setEntities(updatedEntities);
      setProduitExist([])
      console.log("Unknown products deleted and saved to DB");
    } catch (error) {
      console.error("Error saving unknown products:", error);
    }
  };

  const setTable = useCallback(
    async (table, init) => {
      //1 => update table ***** 0 => initialiser table
      var arrayBody = [];
      if (init === 1) {
        var moy = 0
        table.forEach((value) => {
          arrayBody.push({
            designation: value.designation,
            Quantite: value.Quantite,
            code: value.code,
            idProduit: value.idProduit,
            produitfour: value.produitfour,
            prix: value.prix,
            reste: value.reste,
            cartonnage: value.cartonnage,
            code_article: value.code_article,
            total: value.total,
            index: value.index,
            site_produit: value.site_produit,
            nb: value.nb,
            style: value.style,
            commerce: value.commerce,
            tag: value.tag,
            Remise: value.Remise,
            id_site: value.id_site,
            type: value.type
          });
        });
        calculateTotalSum(arrayBody)
        setEntities(arrayBody);
      } else {
        checkProd(table);
      }
    },
    [checkProd]
  );

  function uploadBL(event) {
    var element = document.getElementById("table-BL");
    element.classList.add("hidden");
    let blFile = event.target.files[0];
    if (blFile) {
      var ext = blFile.name.split(".")
      setExtensionFile(ext[(ext.length - 1)]);
      setImage(URL.createObjectURL(blFile));
      if (ext[(ext.length - 1)].toLowerCase() === "pdf") {
        setUploadFile(blFile);
      } else {
        setUploadFile(blFile);
        cropImg(event)
      }
      setEntities([]);
      onFileChange(event);
    }
  }

  const calculateTotalSum = (entities) => {
    var e = [...entities]
    const sum = e.reduce((acc, curr) => {
      return acc + parseFloat(curr.total || 0); // add total to accumulator, default to 0 if total is undefined
    }, 0); // initial accumulator value is 0
    setTotal(sum);
  };
  function cropImg(e) {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage1(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };
  function onFileChange(event) {
    const file = event.target.files[0];
    if (file) {
        setPdfFile(URL.createObjectURL(file));
    }
  }

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);

    setTimeout(() => {
      convertCanvasToImage();
    }, 1000);
  }

  function convertCanvasToImage() {
    let canvases = document.getElementsByClassName("react-pdf__Page__canvas");
    setImage1(canvases)
    if (!canvases || canvases.length === 0) {
      console.warn("no canvases :'(");
      return;
    }
  }

  const removeGrossiste = useCallback(async (list2, id) => {

    var list = [...list2]
    list[0].id_grossiste = null
    list[0].Grossiste = null
    setEntitiesEntete(list)
    setGrossiste(null);
  }, []);



  //get grossiste
  const getGrossiste = useCallback(async () => {
    var grossiste = await dispatch(fetchGrossisteSite({ client }));
    var entities = grossiste.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      arrayOption.push({ value: e.id_grossiste, label: e.raison_sociale, remise_industrie3: e.grossistes?.remise_industrie3, remise_industrie2: e.grossistes?.remise_industrie2 });
    });
    setOptionFour(arrayOption);
  }, [dispatch]);


  const showTable = useCallback(
    async (file, entitiesEntete) => {
      var element = document.getElementById("table-BL");
      element.classList.add("hidden");
      if (typeof file === "object") {
        document.getElementById("loaderTable").classList.remove("hidden");
        const dataArray = new FormData();
        dataArray.append("file", file);
        var bl = await dispatch(extractionsCommande(dataArray));
        var entities = bl.payload;
        element.classList.remove("hidden");
        var array = [...entitiesEntete]
        array[0].Adresse = entities.Adresse;
        setEntitiesEntete(array);

        // if (entities.Grossiste && entities.Grossiste.trim() !== "") {
        //   checkFour(entities.Grossiste, array);
        // }
        setTable(entities.Data, 0);
        notify(1, t("extraction"));
      } else {
        notify(2, t("select_file"));
      }



    },
    [dispatch, setTable]
  );



  const saveTable = useCallback(
    async (entities, uploadFile, entitiesEntete, fourSelected, total, produitExistDeleted) => {


      var verif = true;
      var verifReste = true;
      var ligneMsg = []
      if (entities.length > 0) {
        entities.forEach((data) => {
          if (data.idProduit === null) { verif = false; ligneMsg.push(data.index + 1) }
        });
        entities.forEach((data) => {
          if (data.commerce == 1 && ((data.Quantite == 0) || data.Quantite == "" || data.Quantite == null || isNaN(data.Quantite))) { verif = false; ligneMsg.push(data.index + 1) }
        });

        entities.forEach((data) => {
          if ((data.tag == 1) && data.reste > 0) verifReste = false;
        });


      }
      else { verif = false; }
      var verifCmdD = await dispatch(
        verifCmd({
          numero: entitiesEntete[0].Numero,
          grossiste: entitiesEntete[0].id_grossiste
        })
      );
      var testT = await verifCmdD.payload;
      //setSave(true)

      if (verifReste == false) {
        notify(2, "Le produit n’est recommandable que par multiple de carton");
        return
      }
      if (verif === false || entitiesEntete[0].id_grossiste == null || (entitiesEntete[0].Numero == null || entitiesEntete[0].Numero == "") || entitiesEntete[0].Date == null) {
        if (ligneMsg.length > 0) notify(2, "Vérifier les lignes : " + ligneMsg.join(" ,"));
        else notify(2, t("erreur"));
      } else if (testT === true) {
        notify(2, t("cmd_deja"));
      } else {

        // Vérification si plusieurs types
        let divise = 0;
        const types = [...new Set(entities.filter(e => parseInt(e.Quantite) > 0).map(e => e.type))];
        console.log(types)
        if (types.length > 1) {
          const result = await Swal.fire({
            title: 'Division Commande',
            text: "La commande contient plusieurs types (AMM et AMC). Voulez-vous diviser la commande ?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Oui, diviser',
            cancelButtonText: 'Non',
          });

          if (result.isConfirmed) {
            divise = 1;
          }
        }



        const dataArray = new FormData();
        dataArray.append("file", uploadFile);
        var namefile = uploadFile.name != undefined ? uploadFile.name : file;
        dataArray.append("name", namefile);

        if (entitiesEntete[0].id_grossiste !== null) {
          if (saveTableCalled.current) return;
          saveTableCalled.current = true
          setSave(true)
          dispatch(saveFile(dataArray)).then((e) => {
            var filename = e.payload.filename;
            dispatch(commandeAdded({
              produitExistDeleted,
              divise, id_site: client == "/medis" ? 2 : 3,
              file: filename, type_insert: 2, ligneCommande: entities, Montant: total, enteteCmd: entitiesEntete, filename: filename, fileimport: namefile
            })).then((e) => {
              if (e.payload === true) {
                notify(1, t("add_txt"));
                setTimeout(() => {
                  window.location.replace(client + "/commandeList")
                }, 800);
              } else {

                setSave(false)
                saveTableCalled.current = false
                notify(2, t("erreur"));
              }
            });

          });
        } else {
          notify(2, t("Grossiste.obligatoire"));
        }
      }

    },
    [dispatch, fileName, traitment]
  );

  function AjoutLigne(event) {
    var list = [];
    if (entities.length > 0) list = [...entities];
    list[list.length] = {
      designation: null,
      Quantite: 0,
      index: list.length,
      idProduit: null,
      code: '',
      prix: 0,
      reste: 0,
      tag: 0,
      Remise: 0,
      cartonnage: 0,
      code_article: '',
      total: 0,
      nb: 0,
      reste: null,
      id_site: null,
      site_produit: null,
      type: null,
      commerce: null
    };

    setEntities(list);
  }

  const inputRefs = useRef([]);

  const handleKeyDown = (event, index) => {
    if (event.key === "Enter" || event.key === "Tab") {
      event.preventDefault(); // Prevent default form submission or tabbing
      const nextIndex = index + 1; // Move to the next input
      if (inputRefs.current[nextIndex]) {
        inputRefs.current[nextIndex].focus(); // Focus the next input
      }
    }
  };



  const ListTable = ({ entities, produitSelect, resteZero, list }) => {
    return (
      <table className="table table-add table-bordered">
        <thead>
          <tr className="table-info">
            <th>Id</th>
            <th>{t('code_pct')}</th>
            <th>{t('code_article')}</th>
            <th>{t('designation')}</th>
            <th>{t('remise')}</th>
            <th>{t('prix')} (HT TND)</th>
            <th>{t('cartonnage')}</th>
            <th>{t('quantite_cmd')}</th>
            <th>{t('nb_carton')}</th>
            <th>{t('reste')}</th>
            <th>{t('prix_total')} (HT TND)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody className="commande-import4" >
          {entities.map((entity, index) => (
            <tr key={index} className={entity.commerce == 0 ? "no-commerce" : entity.reste > 0 ? "reste-warning" : null}>
              <td>{entity.index + 1}</td>
              <td>{entity.tag == 1 ? <i style={{ color: "#9C27B0", fontSize: "15px", marginRight: "10px" }} className="fa-solid fa-cube"></i> : null}{entity.code}</td>
              <td>{entity.code_article}</td>
              <td>
                <div id="roleClass">
                  {entity.idProduit !== null ? (
                    <Form.Group className="desinationProduit">
                      <Form.Control
                        className="green"
                        readOnly
                        value={entity.designation}
                        placeholder="Designation"
                        type="text"
                      ></Form.Control>
                      {entity.commerce == 1 ? (
                        <Button
                          variant="danger"
                          size="sm"
                          className="text-danger btn-link delete"
                          onClick={() => {
                            removeProduit(
                              entities,
                              produitSelect,
                              index
                            );
                          }}
                        >
                          <i className="fas fa-times"></i>
                        </Button>
                      ) : null}
                    </Form.Group>
                  ) : (
                    <div className="table-bl">
                      {entity.designation != null ? (
                        <Form.Group className="desinationProduit">
                          <Form.Control
                            className="red"
                            readOnly
                            value={
                              entity.designation
                            }
                            placeholder="Designation"
                            type="text"
                          ></Form.Control>
                        </Form.Group>
                      ) : (
                        ""
                      )}
                      <Select
                        className="react-select primary "
                        classNamePrefix="react-select"
                        name="Produit"
                        placeholder="Produit"
                        value={produitSelect[index]}
                        onChange={(v) => {
                          confirmMessageProduit(entities, produitSelect, index, v, produitExist, produitExistDeleted)
                        }}
                        options={optionProduit}
                      />
                    </div>
                  )}
                </div>
              </td>
              <td>{entity.Remise}</td>
              <td>{new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(entity.prix)}</td>
              <td>{entity.cartonnage}</td>
              <td>
                <Form.Group>
                  <input
                    className={entity.style === "red" ? "redBorder form-control" : "defaultBorder form-control"}
                    defaultValue={entity.Quantite}
                    placeholder="Quantite"
                    type="number"
                    pattern="\d+"
                    onBlur={(value) => {
                      let e = [...entities];

                      let rawQuantite = parseInt(value.target.value.replace(/[^0-9]/g, '')) || 0;


                      if (
                        e[index].cartonnage > 0 &&
                        rawQuantite / e[index].cartonnage >= 0.6 &&
                        e[index].tag == 2
                      ) {
                        rawQuantite = Math.ceil(rawQuantite / e[index].cartonnage) * e[index].cartonnage;
                        const seuil = e[index].cartonnage * 0.6;
                        e[index].style = "red"
                        notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
                      }


                      e[index].Quantite = rawQuantite;

                      e[index].nb = e[index].cartonnage > 0 ? parseInt(e[index].Quantite / e[index].cartonnage) : 0
                      if (e[index].Quantite > 0 && e[index].Quantite < e[index].cartonnage) e[index].reste = parseInt(e[index].cartonnage - e[index].Quantite)
                      else if (e[index].Quantite > 0 && (e[index].Quantite % parseInt(e[index].cartonnage)) > 0) {
                        e[index].reste = parseInt(e[index].cartonnage - (e[index].Quantite % parseInt(e[index].cartonnage)))
                      } else if (e[index].Quantite == 0) {
                        e[index].reste = null
                      } else {
                        e[index].reste = 0
                      }
                      let remiseDecimal = 0;
                      if (e[index].Remise && e[index].Remise !== 0) {
                        remiseDecimal = typeof e[index].Remise === "number" ? e[index].Remise : parseFloat(e[index].Remise);
                        if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
                      }



                      if ((e[index].tag == 1) && e[index].reste > 0) {
                        e[index].Quantite += e[index].reste
                        rawQuantite += e[index].reste
                        e[index].nb += 1
                        e[index].reste = 0
                        e[index].style = "red"
                        notify(2, "Le produit n’est recommandable que par multiple de carton");
                      }

                      e[index].total = rawQuantite
                        ? (e[index].prix * rawQuantite * (1 - remiseDecimal)).toFixed(3)
                        : 0;

                      if (resteZero == 1) {
                        list[e[index].index].Quantite = rawQuantite;

                        list[e[index].index].nb = list[e[index].index].cartonnage > 0 ? parseInt(list[e[index].index].Quantite / list[e[index].index].cartonnage) : 0

                        if (list[e[index].index].Quantite < list[e[index].index].cartonnage) list[e[index].index].reste = parseInt(list[e[index].index].cartonnage - list[e[index].index].Quantite)
                        else if ((list[e[index].index].Quantite % parseInt(list[e[index].index].cartonnage)) > 0) {
                          list[e[index].index].reste = parseInt(list[e[index].index].cartonnage - (list[e[index].index].Quantite % parseInt(list[e[index].index].cartonnage)))
                        } else {
                          list[e[index].index].reste = 0
                        }
                        list[e[index].index].total = (list[e[index].index].prix * parseInt(list[e[index].index].Quantite) * (1 - remiseDecimal)).toFixed(3)

                        calculateTotalSum(list);
                        setEntities(list)
                      }

                      if (resteZero == 0) { setEntities(e); calculateTotalSum(e); }
                      else setEntitiesReste(e)


                    }}
                    onKeyDown={(event) => handleKeyDown(event, index)}
                    ref={(el) => (inputRefs.current[index] = el)} // Reference to the input
                    name={`Quantite-${index}`}
                  />
                </Form.Group>
              </td>
              <td>{entity.nb}</td>
              <td>{entity.reste}</td>
              <td>{new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(entity.total)}</td>
              <td>
                <Button
                  id={"idLigneR_" + index}
                  onClick={(ev) => {
                    deleteLigne(index);
                  }}
                  variant="danger"
                  size="sm"
                  className="text-danger btn-link delete"
                >
                  <i className="fa fa-trash" id={"idLigneR_" + index} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  function getProduitReste(list, resteZero) {
    const filteredList = list.filter(item => {
      if (resteZero === 1) {
        if (item.idProduit != null) return item.reste != 0 && item.reste != null;
      } else {
        return true;
      }
    });
    setEntitiesReste(filteredList)
  }


  const removeProduit = useCallback(
    async (list2, select, id) => {

      var list = [...list2]
      list[id].idProduit = null;
      list[id].designation = null;
      list[id].cartonnage = 0;
      list[id].reste = 0;
      list[id].nb = 0;
      select[id] = null;
      setProduitSelect(select);
      setEntities(list);
      setTable(list, 1);
    },
    [setTable]
  );

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);

  useEffect(() => {
    verifToken()
    getNumCmd(idUser)
    if(obj.user.id_role != 6 )getGrossiste();
    getproduit(remise_industrie3, remise_industrie2);

  }, [remise_industrie3, remise_industrie2]);
  return (
    <>
      <Container fluid className="responsive-BL table-dynamique">
        {alert}
        <ToastContainer />
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-outline mr-1 float-left"
              type="button"
              variant="info"
              onClick={() => {
                window.history.back();
              }}
            >
              <span className="btn-label">
                <i className="fas fa-list"></i>
              </span>
              {t('list')}
            </Button>
          </Col>
        </Row>

        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">{t('new_commande')}</Card.Title>
              </Card.Header>

              <Card.Body>
                <div className="text-center">
                  <div className=" style-canvas">
                    {file ? <iframe width="100%" height="500px" src={`${pdfFile}#toolbar=0`}></iframe>
                      :
                      <div className="text-center">
                        <form>
                          <Form.Group className="float-left">
                            <Form.Control
                              id="test"
                              name="file"
                              type="file"
                              accept="application/pdf"
                              onChange={(e) => uploadBL(e)}
                            ></Form.Control>
                          </Form.Group>
                        </form>


                        <div className="clear"></div>
                        <br></br>
                        {extensionFile === "" ? (
                          <h4>
                            {t("select_pdf")}
                          </h4>
                        ) : extensionFile.toLowerCase() === "pdf" ? (
                    <div >
                      <iframe width={"100%"}  style={{ height: "700px" }} src={`${pdfFile}#toolbar=0`}></iframe>
                     </div>

                        ) : (
                          <div className="image-bl">
                            <img src={image} alt="" />
                          </div>
                        )}</div>
                    }
                    <br />
                  </div>
                  <br />
                  <br />
                  <Button
                    className="btn-wd btn-outline mr-1 float-right extraction"
                    id="blExt"
                    type="button"
                    variant="info"
                    onClick={(v) => {
                      if (traitment === false)
                        showTable(uploadFile, entitiesEntete);
                    }}
                  >
                    <span className="btn-label">
                      <i className="fas fa-cogs"></i>
                    </span>
                    {t("extraction")}
                  </Button>
                </div>

                <br clear="all"></br>
                <div className="text-center">
                  <img
                    id="loaderTable"
                    className="hidden"
                    src={require("../../assets/img/loader.gif")}
                    alt="loader"
                  />
                </div>
                <br clear="all"></br>
                <hr></hr>
                <Row>
                  {produitExist.length > 0 ?
                    <> <Col md="12">
                      <button className="btn btn-danger ml-1" onClick={handleDeleteUnknownProducts}>Supprimer les Produits Inconnus</button>
                    </Col>
                      <Col md="12">
                        <table className="table tableinconnue">
                          <thead style={{ backgroundColor: produitExist.length > 0 ? 'red' : 'transparent', color: "#fff" }}>
                            <tr>
                              <th style={{ backgroundColor: produitExist.length > 0 ? 'red' : 'transparent', color: "#fff" }}>ID</th>
                              <th style={{ backgroundColor: produitExist.length > 0 ? 'red' : 'transparent', color: "#fff" }}>Code</th>
                              <th style={{ backgroundColor: produitExist.length > 0 ? 'red' : 'transparent', color: "#fff" }}>Designation</th>
                            </tr>
                          </thead>
                          <tbody>
                            {produitExist.map((item, index) => (
                              <tr key={index}>
                                <td>{item.index}</td>
                                <td>{item.code}</td>
                                <td>{item.designation}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Col>

                    </>
                    : null}

                </Row>
                <br clear="all"></br>
                <hr></hr>
                <br></br>
                <Row className="hidden" id="table-BL">
                  <Col md="12">
                    <hr></hr>
                    <div>
                      <ReactTable
                        data={entitiesEntete}
                        columns={[
                          obj.user.id_role != 6 && {
                            Header: "Grossiste",
                            accessor: "grossiste",
                            width: 200,
                            Cell: ({ cell }) => (
                              <Select
                                className="react-select"
                                name="Grossiste"
                                placeholder="Grossiste"
                                value={fourSelected}
                                onChange={(v) => {
                                  console.log("👉 Test L : nouveau grossiste sélectionné", v); // 🔥 test log

                                  setFourSelected(v);
                                  var prev = [...entitiesEntete];
                                  prev[0].Grossiste = v.label;
                                  prev[0].id_grossiste = v.value;
                                  prev[0].remise_industrie3 = v.remise_industrie3;
                                  prev[0].remise_industrie2 = v.remise_industrie2;

                                  setRemise_industrie2(v.remise_industrie2);
                                  setRemise_industrie3(v.remise_industrie3);

                                  // 🔥 test recalcul remise
                                  const updatedEntities = entities.map(e => {
                                    let remiseDecimal = 0;
                                    let remise = 0
                                    remiseDecimal = client === "/medis" ? v.remise_industrie2 : v.remise_industrie3;
                                    remise = client === "/medis" ? v.remise_industrie2 : v.remise_industrie3;
                                    if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;


                                    console.log("👉 Test L - recalcul ligne:", e.designation, "ancienne remise:", e.Remise, "nouvelle remise:", remiseDecimal);

                                    return {
                                      ...e,
                                      Remise: remise,
                                      total: e.Quantite
                                        ? (e.prix * e.Quantite * (1 - remiseDecimal)).toFixed(3)
                                        : 0
                                    };
                                  });
                                  calculateTotalSum(updatedEntities)
                                  setTable(updatedEntities, 1);
                                  setEntitiesEntete(prev);
                                }}

                                options={optionFour}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                                }}
                              />
                            ),
                          },
                          {
                            Header: "Numero",
                            accessor: "Numero",
                            width: 200,
                            Cell: ({ cell }) => (
                              <Form.Group>
                                <Form.Control
                                  value={cell.row.values.Numero}
                                  placeholder="Numero"
                                  type="text"
                                  readOnly
                                ></Form.Control>
                              </Form.Group>
                            ),
                          },
                          {
                            Header: "Date",
                            accessor: "Date",
                            width: 200,
                            Cell: ({ cell }) => (
                              <Form.Group>
                                <Form.Control
                                  defaultValue={cell.row.values.Date}
                                  placeholder="Date"
                                  type="date"
                                  readOnly
                                // onChange={(v) => {
                                //   var entete = entitiesEntete;
                                //   entete[0].Date = v.target.value;
                                //   setEntitiesEntete(entete);
                                // }}
                                ></Form.Control>
                              </Form.Group>
                            ),
                          }
                        ].filter(Boolean)}
                        className="-striped -highlight primary-pagination"
                      />
                    </div>

                  </Col>
                  <Col md="12">
                    <hr></hr>
                    <h4 className="float-left"><strong>{t('montant_total')}: {new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(total)} HT TND</strong></h4>
                    <Row className="float-right" style={{ width: "50%", margin: "30px 0 15px" }}>
                      <Col md="12">
                        <Row>
                          <Col md="6">
                            <Form.Group>
                              <Form.Check>
                                <Form.Check.Label>
                                  <Form.Check.Input
                                    type="checkbox"
                                    checked={resteZero == 1 ? true : false}
                                    onChange={(v) => {
                                      if (v.target.checked) {
                                        setResteZero(1);
                                        getProduitReste(entities, 1)
                                      }
                                      else setResteZero(0)
                                    }}
                                  ></Form.Check.Input>
                                  <span className="form-check-sign"></span>
                                  <label>{t('produit_en_vrac')}</label>
                                </Form.Check.Label>
                              </Form.Check>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <br clear="all"></br>
                    <br clear="all"></br>
                    <hr></hr>

                    <ListTable entities={resteZero == 0 ? entities : entitiesReste} list={entities} produitSelect={produitSelect} resteZero={resteZero} />

                    <br></br>
                    <hr></hr>
                    {!save && resteZero == 0 ? <Button
                      className="btn-wd btn-outline mr-1 float-left"
                      type="button"
                      variant="info"
                      nom="redac"
                      onClick={(ev) => AjoutLigne()}
                    >
                      {t("add_product")}
                    </Button> : ""}
                  </Col>

                  <Col md="12">
                    {!save ? <Button
                      id="saveBL"
                      className="btn-wd btn-outline mr-1 float-right"
                      type="button"
                      variant="info"
                      onClick={() =>
                        saveTable(entities, uploadFile, entitiesEntete, fourSelected, total, produitExistDeleted)
                      }
                    >
                      <span className="btn-label">
                        <i className="fas fa-check"></i>
                      </span>
                      {t("save_draft")}
                    </Button> : ""}

                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container >
    </>
  );
}
export default AddCommande;
